import { render, staticRenderFns } from "./ServerMessage.vue?vue&type=template&id=1ba62b2a&scoped=true&"
import script from "./ServerMessage.vue?vue&type=script&lang=js&"
export * from "./ServerMessage.vue?vue&type=script&lang=js&"
import style0 from "./ServerMessage.vue?vue&type=style&index=0&id=1ba62b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba62b2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
